import {makeAutoObservable} from "mobx";
import {api, catchApi,} from "../../api";
import {validationStore} from "../ValidationStore";
import {PrinterTypeDto, UserConfigurationDto} from "../../api/ums";
import {equals} from "../../utils";
import {UserPrinterFormData} from "../../components/page/ums/UserPrinterConfiguration";
import {userPrinterPreferenceStore} from "./UserPrinterPreferenceStore";


class UserConfigurationStore {
    get data(): UserConfigurationDto | undefined {
        return this._data;
    }

    set data(value: UserConfigurationDto | undefined) {
        this._data = value;
    }

    private get original(): UserConfigurationDto | undefined {
        return this._original;
    }

    private set original(value: UserConfigurationDto | undefined) {
        this._original = value;
    }

    get valid(): boolean {
        return this._valid;
    }

    set valid(value: boolean) {
        this._valid = value;
    }

    get saving(): boolean {
        return this._saving;
    }

    set saving(value: boolean) {
        this._saving = value;
    }

    get dirty(): boolean {
        return !equals(this.original, this.data)
    }

    get formData(): UserPrinterFormData {
        const printer = (this.data?.defaultPrinters || [])
            .reduce((buffer, value) => {
                buffer.set(value.printerType, value.printerId);
                return buffer
            }, new Map<PrinterTypeDto, string | undefined>())

        return {
            printer
        }
    }

    set formData({
                     printer
                 }: UserPrinterFormData) {

        const defaultPrinters = Array.from(printer.keys())
            .filter(key => printer.get(key))
            .map(key => ({
                printerId: printer.get(key) as string,
                printerType: key as PrinterTypeDto,
            }))

        this.data = {
            defaultPrinters: defaultPrinters
        }
    }

    private _original: UserConfigurationDto | undefined = undefined
    private _data: UserConfigurationDto | undefined = undefined
    private _saving: boolean = false
    private _valid: boolean = true

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => {
            return await api.ums.api.getConfiguration()
        })

        this.original = result?.data
        this.reset()
    }


    async save() {
        const {data} = this
        if (!data) {
            return
        }
        this.saving = true;
        const result = await catchApi(async () => {
            return await api.ums.api.updateConfiguration(data)
        })
        this.original = result?.data
        userPrinterPreferenceStore.load().finally()
        this.reset()
        return this.data
    }

    async validate() {
        const {data} = this
        if (!data) {
            return
        }
        await validationStore.validate(api.ums.api.validateConfiguration, this.data)
        this.valid = Boolean(validationStore.valid)
    }

    reset() {
        const {original} = this
        if (!original) {
            return
        }
        this.data = JSON.parse(JSON.stringify(this.original))
        this.saving = false
        this.valid = true
        validationStore.reset()
    }
}

const userConfigurationStore = new UserConfigurationStore()

export {
    userConfigurationStore
}
